import Vue from 'vue'
import Amplify from 'aws-amplify'
import App from '@/app'
import { postLogger } from '@/api'
import awsconfig from '@/aws-exports'
import { IS_LOCAL } from '@/constants'
import vuetify from '@/plugins/vuetify'
import router from '@/router/'
import store from '@/store/'

if (!IS_LOCAL) {
  Amplify.configure(awsconfig)
}

Vue.config.productionTip = false
Vue.config.performance = true
Vue.config.errorHandler = (err, vm, info) => {
  console.error(err)
  try {
    postLogger({
      timestamp: new Date().getTime(),
      level: 'ERROR',
      name: err.name || '',
      message: err.message || '',
      stack: err.stack || '',
      info: info || ''
    })
  } catch (e) {
    console.error(e)
  }
}

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
